import { render } from "./Beneficiary.vue?vue&type=template&id=f35953a8&scoped=true&ts=true"
import script from "./Beneficiary.vue?vue&type=script&lang=ts"
export * from "./Beneficiary.vue?vue&type=script&lang=ts"

import "./Beneficiary.vue?vue&type=style&index=0&id=f35953a8&lang=scss&scoped=true"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f35953a8"]])

export default __exports__